import { render, staticRenderFns } from "./notificationpage.vue?vue&type=template&id=64364c9d&scoped=true&"
import script from "./notificationpage.vue?vue&type=script&lang=js&"
export * from "./notificationpage.vue?vue&type=script&lang=js&"
import style0 from "./notificationpage.vue?vue&type=style&index=0&id=64364c9d&prod&scoped=true&lang=css&"
import style1 from "./notificationpage.vue?vue&type=style&index=1&id=64364c9d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64364c9d",
  null
  
)

export default component.exports